import { checkRoutePermission } from '@/components/Auth/checkUserPermissions';
import { TabType, ViewConfig, ViewPaths, VIEWS } from '@/types/views';
import { PermissionDTO } from '@/api/trafikportalen';

export const isValidView = <T extends TabType>(
  view: string,
  type: T,
): view is ViewPaths<T> => {
  if (
    type === 'traveller' &&
    [
      'student-travels',
      'student-transportation',
      'student-child-and-youth',
    ].includes(view)
  ) {
    return true;
  }
  return getViewsForType(type).some((v: ViewConfig) => v.path === view);
};

export const getViewsForType = (type: TabType) => {
  return VIEWS.find((view) => view.type === type)?.views ?? [];
};

export const getDefaultView = (type: TabType): string => {
  const views = getViewsForType(type);
  return views[0]?.path ?? '';
};

export const hasViewPermission = <T extends TabType>(
  view: TabType,
  type: T,
  fallbackPermission: PermissionDTO,
) => {
  const views = getViewsForType(type);
  const viewData = views.find((v) => v.path === view);
  return checkRoutePermission({
    permission: viewData?.permission ?? fallbackPermission,
  });
};
